import React, { Component } from "react";
import { connect } from "react-redux";

import MediaComponent from "./MediaComponent";

export class Media extends Component {
  render() {
    const { media, language } = this.props;

    return <MediaComponent media={media} language={language} />;
  }
}

// Connected Component
const mapStateToProps = state => ({
  language: state.params.lng
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Media);



// WEBPACK FOOTER //
// ./src/components/Common/Album/Media/index.js